<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>
  
<c-modal [visible]="bShowReason" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="rejectionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Why do you want to reject this lead?</h5>
            <button (click)="closeReasonModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
        <c-input-group class="mb-3 has-validation" >
            <span cInputGroupText>
                Reason
            </span>
            <input [valid]="bValidReason" cFormControl formControlName="reasonControl" id="RejectReason" type="text"/>
            <c-form-feedback [valid]="bValidReason">{{ifReasonValid()}}</c-form-feedback>
        </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeReasonModal()">
            Don't want to reject
            </button>
            <button cButton color="primary" (click)="approveOrRejectLead(false)">Confirmed - please reject</button>
        </c-modal-footer>
    </form>
</c-modal>

<c-modal [visible]="bShowCIFPopup" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="CIFForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Enter the CIF</h5>
            <button (click)="closeCIFModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
        <c-input-group class="mb-3 has-validation" >
            <span cInputGroupText>
                CIF
            </span>
            <input [valid]="bValidCIF" cFormControl formControlName="CIFControl" id="CIFValie" type="text"/>
            <c-form-feedback [valid]="bValidCIF">{{CIFError}}</c-form-feedback>
        </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeCIFModal()">
            Cancel
            </button>
            <button cButton color="primary" (click)="getCifDetails()">Proceed</button>
        </c-modal-footer>
    </form>
</c-modal>

<div *ngIf="true">
  <c-navbar expand="lg" class="border-bottom border-bottom-3 border-bottom-primary">
    <c-container fluid>
      <form cForm class="row g-2" [formGroup]="cifSearchForm" (ngSubmit)="getLeads()">
        <div class="row">
          <div class="col">
              <c-input-group class="mb-3 has-validation" >
                  <span cInputGroupText>
                      Company Name
                  </span>
                  <input cFormControl formControlName="searchByCompanyControl" id="CNAME" placeholder="Partial Name" type="text" (keypress)="onCompanyNameChange()"/> 
                  <span cInputGroupText>
                      OR
                  </span>
              </c-input-group>
          </div>
          <div class="col">
              <c-input-group class="mb-3 has-validation" >
                  <span cInputGroupText>
                      Trade License
                  </span>
                  <input cFormControl formControlName="searchByTradeLicenseControl" id="CTLICENSE" placeholder="Trade License" type="text" (keypress)="onTradeLicenseChange()"/>
              </c-input-group>
          </div>
          <div class="col">
            <div class="row">
                <div class="col-sm-auto">
                    <button cBgColor="{{searchBtnColor}}" cButton type="submit">
                        Search
                    </button>
                </div>
                <div class="col-sm-auto">
                    <button cBgColor="{{searchAllBtnColor}}" cButton (click)="getAllLeads()">
                        Get All Leads
                    </button>
                </div>
            </div>
          </div>
        </div>
      </form>
    </c-container>
  </c-navbar>

  <c-smart-table
    [columnSorter]="true"
    [columns]="columns"
    [columnFilter]="true"
    [itemsPerPageSelect]="true"
    [itemsPerPage]="15"
    [items]="usersData"
    [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }"
    (rowClick)="rowSelected($event)"
    clickableRows
    header
    pagination>
    <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
      <td>
        <ng-container [ngSwitch]="columnName">
            <ng-container *ngSwitchCase="'requestedOn'">
               {{(getLeadDate(item))}}
            </ng-container>
            <ng-container *ngSwitchCase="'reference'">
                <button cBgColor="success" cTooltip="Approve" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="showCIFModal(item)" ><svg cIcon name="cilThumbUp"></svg></button>
            </ng-container>
            <ng-container *ngSwitchCase="'id'">
                <button cBgColor="danger" cTooltip="Reject" cTooltipPlacement="top" style="margin: 5px;" cButton (click)="showReasonModal(item)" ><svg cIcon name="cilThumbDown"></svg></button>
            </ng-container>
            <ng-container *ngSwitchDefault>
                {{tdContent}}
            </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </c-smart-table>
</div>
